import { defineMessages } from 'react-intl'

const scope = `procurify.expense.featureSet.ExpenseReportEditView`

export default defineMessages({
  editExpenseLineItemModalTitle: {
    id: `${scope}.editExpenseLineItemModalTitle`,
    defaultMessage: 'Edit expense item',
  },
  editExpenseLineMenuLabel: {
    id: `${scope}.editExpenseLineMenuLabel`,
    defaultMessage: 'Edit expense item',
  },
  duplicateToolbarButton: {
    id: `${scope}.duplicateToolbarButton`,
    defaultMessage: 'Duplicate expense report',
  },
  duplicateOverrideConfirmHeader: {
    id: `${scope}.duplicateOverrideConfirmHeader`,
    defaultMessage: 'Confirmation',
  },
  duplicateOverrideConfirmMessage: {
    id: `${scope}.duplicateOverrideConfirmMessage`,
    defaultMessage:
      'This action will override the previous expense report draft.',
  },
})
